import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const financeApi = {
    confirmVolumeProjection: async (key) => {
        const url = 'api/finance/v1/volumeProjection/confirm';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
    },
    deleteDriverTipsDriverRecords: async (ids) => {
        const url = 'api/finance/v1/driverTips/driverReport';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ ids }),
        });
    },
    downloadTipAudit: async (startDate, endDate) => {
        const filename = 'tip_audit.csv';
        const url = `api/finance/v1/driverTips/audit?startDate=${startDate}&endDate=${endDate}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, filename);
            }
        } catch (e) {
            logError(e);
        }
    },
    getDriverTipsBackChargeReport: async (startDate) => {
        const url = `api/finance/v1/driverTips/backCharge?startDate=${startDate}`;
        return mmFetchWithResponse(url);
    },
    getDriverTipsCostCenterReport: async (hasTipsOnly, startDate, endDate) => {
        let url = `api/finance/v1/driverTips/costCenter?startDate=${startDate}&endDate=${endDate}`;
        if (hasTipsOnly === true) {
            url += '&hasTipsOnly=true';
        }
        return mmFetchWithResponse(url);
    },
    getDriverTipsDriverReport: async (startDate, endDate) => {
        const url = `api/finance/v1/driverTips/driverReport?startDate=${startDate}&endDate=${endDate}`;
        return mmFetchWithResponse(url);
    },
    getPurchaseOrdersWithPaymentInfo: async () => {
        const url = `api/finance/v1/purchaseOrder`;
        return mmFetchWithResponse(url);
    },
    getTrucksWithPaymentInfo: async () => {
        const url = `api/finance/v1/fobTruck`;
        return mmFetchWithResponse(url);
    },
    getVolumeProjectionUploads: async () => {
        const url = `api/finance/v1/volumeProjection`;
        return mmFetchWithResponse(url);
    },
    payPurchaseOrder: async (id, sendParams) => {
        const url = `api/finance/v1/purchaseOrder/${id}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    payTruck: async (id, sendParams) => {
        const url = `api/finance/v1/fobTruck/${id}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    syncDriverTipsTimecards: async () => {
        const url = `api/finance/v1/driverTips/timeCards`;
        return mmFetchWithResponse(url);
    },
    uploadVolumeProjection: async (data) => {
        const formData = new FormData();
        formData.append('file', data.file);

        const url = 'api/finance/v1/volumeProjection/upload';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    updateVolumeProjection: async (id, sendParams) => {
        const url = `api/finance/v1/volumeProjection/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
};

export { financeApi };
